import React from 'react';

const PrivacyPolicyPage = () => {
    return (<>
    <h1>Privacy Policy</h1>
    <p><strong>Last updated:</strong> June 27, 2025</p>
    <p>This Privacy Policy describes how our data dashboard application (Gemius Programmatic Dashboard) collects, uses, and protects personal and confidential data from clients.</p>
    <h2>1. Information We Collect</h2>
    <ul>
        <li>Personal identification information (e.g., name, email address)</li>
        <li>Confidential business data integrated from third-party platforms</li>
    </ul>
    <h2>2. How We Use the Information</h2>
    <p>We use the collected data strictly to:</p>
    <ul>
        <li>Display dashboards and analytics specific to each authenticated client</li>
        <li>Process, aggregate, and visualize data from integrated third-party services</li>
        <li>Improve the functionality and performance of the Application</li>
    </ul>
    <h2>3. Data Sharing</h2>
    <p>We do not sell, trade, or rent clients’ data to others. Data may be shared only with the client's explicit consent or as required by law.</p>
    <h2>4. Data Security</h2>
    <p>We implement industry-standard technical and organizational measures to protect data from unauthorized access, alteration, disclosure, or destruction.</p>
    <h2>5. Contact</h2>
    <p>If you have any questions about this policy, you may contact us at <a href="mailto:help.ro@gemius.com">help.ro@gemius.com</a></p>
    </>)
}

export default PrivacyPolicyPage;